"use client";
import { Logger } from "cy-logging";
import { createClientDatadogLogger } from "cy-datadog/client";
import { env } from "@/env/client";

export function createLoggerClient(name?: string): Logger {
  return createClientDatadogLogger(name ?? env.NEXT_PUBLIC_APP_ID);
}
